// extracted by mini-css-extract-plugin
export default {"product-controller":"Controller_product-controller__XHheN","down":"Controller_down__X8ekq","products":"Controller_products__GYKKD"};